import React, { Component } from "react";
import { Tab, TabList, TabPanel, Tabs } from "react-tabs";
import SimpleDataTable from "../../../../modules/SimpleDataTable";
import Button from "../../../../modules/commons/Button";
import { Scanner } from "@yudiel/react-qr-scanner";
import SimpleModal from "../../../../modules/popup/SimpleModal";
import { Condition } from "../../../common/Constants";
import SimpleDDL from "../../../../modules/SimpleDDL";
import Api from "../../../../Services/Api";
import {fetchDataAsync, hasNilOrEmpty, isNotNilAndEmpty} from "../../../../Services/Utils";
import * as R from "ramda";
import SimpleAlert from "../../../../modules/popup/SimpleAlert";
import FlexView from "react-flexview";
import SimpleButton from "../../../../modules/commons/SimpleButton";
import SimpleLoadingOverlay from "../../../../modules/popup/SimpleLoadingOverlay";
import ErrorAction from "../../../../Redux/ErrorRedux";
import {connect} from "react-redux";
import { defaultTableChange } from "../../../../modules/custom/customTable";

class HadiahTab extends Component {
  conditionOptions = [
    {
      label: Condition.OK,
      value: Condition.OK,
    },
    {
      label: Condition.NOT_OK,
      value: Condition.NOT_OK,
    },
  ];

  commonTableColumns = [
    {
      name: "",
      label: "No",
      options: {
        customBodyRender: (_, { rowIndex }) => <>{rowIndex + 1}</>,
      },
    },
    { name: "giftCode", label: "Kode Hadiah" },
    { name: "giftName", label: "Nama Hadiah" },
    { name: "giftCategory", label: "Jenis Hadiah" },
  ];

  denganQRTableColumns = [
    ...this.commonTableColumns,
    { name: "giftBarcode", label: "QR Code" },
    {
      name: "",
      label: "Aksi",
      options: {
        customBodyRender: (_, tableMeta) => (
          <Button
            type="button"
            className="btn"
            style={{ borderRadius: "50%" }}
            disabled={this.props.done}
            onClick={() => this.handleShowScanner(tableMeta.rowIndex, "scan")}
          >
            <span>
              <i className="fa fa-qrcode"></i>
            </span>
          </Button>
        ),
      },
    },
  ];

  tanpaQRTableColumns = [
    ...this.commonTableColumns,
    { name: "giftQty", label: "Jumlah" },
    {
      name: "giftStatus",
      label: "Aksi",
      options: {
        customBodyRender: (val, { rowIndex }) => (
          <SimpleDDL
            id={`select_options_condition_${rowIndex}`}
            box="search"
            containerclassname="margin-bottom-none"
            value={this.conditionOptions.find((c) => c.value === val)}
            options={this.conditionOptions}
            readOnly={this.props.done}
            onChange={(value) => this.handleChangeStatus(rowIndex, value)}
          />
        ),
        setCellProps: () => ({
          style: { width: "150px" },
        }),
      },
    },
  ];

  constructor(props) {
    super(props);
    this.state = {
      scannerVisible: false,
      failedQRAlertVisible: false,
      alertVisible: false,
      alertMessage: null,
      selectedIndex: null,
      qrCode: null,
      pagination: {
        limit: 5,
        page: 1,
      },
      paginationQR: {
        limit: 5,
        page: 1,
      },
      alertType: null,
    };
  }

  handleShowScanner = (index, type) => {
    if(type === "scan" && this.props?.data?.giftBarcode?.[index]?.menyusul){
      return this.handleAlertVisibility("Scan Tidak dapat dilakukan, Karena item tersebut sudah masuk ke Ekspedisi - Menyusul", "info")
    }
    this.setState({
      scannerVisible: !this.state.scannerVisible,
      selectedIndex: index,
    });
  };

  handleChangeStatus = (idx, value) => {
    this.props.onChangeStatus("gift", idx, "giftStatus", value.value);
  };

  handleScanQR = async (data) => {
    this.handleTriggerLoading();
    const barcodeFromScan = data[0].rawValue;
    const itemCode = this.props.data.giftBarcode[this.state.selectedIndex].giftCode;
    const barcode = this.props.data.giftBarcode[this.state.selectedIndex].giftBarcode;

    const request = {
      nameCategory: "GIFT",
      encryptBarcode: barcodeFromScan,
      kodeCabang: this.props.kodeCabang,
      codeItem: itemCode,
      trxType: "TRX_IN"
    }

    const res = await fetchDataAsync({
      asyncFn: Api.create("NAGAMAS_TRANSACTION").findBarcodeKsuBrlHdhMutation,
      setError: this.props.setError,
      menuName: "Belum PDI",
      args: request,
    });

    let barcodeFromDB = null;
    let itemCodeFromDB = null;
    if (res.ok) {
      barcodeFromDB = res.data.data?.barcode;
      itemCodeFromDB = res.data.data?.kodeItem;
    }

    this.setState((prevState) => ({...prevState, qrCode: barcodeFromDB}));
    if (isNotNilAndEmpty(itemCode, itemCodeFromDB) && !R.equals(itemCode, itemCodeFromDB) || hasNilOrEmpty(itemCode, itemCodeFromDB)) {
      this.handleFailedQRAlertVisibility();
      this.handleShowScanner();
      this.handleTriggerLoading();
      return;
    }

    if (R.and(isNotNilAndEmpty(barcode, barcodeFromDB), !R.equals(barcode, barcodeFromDB))) {
      this.handleAlertVisibility("QR Code sudah di scan dengan QR code yang berbeda, apakah ingin mengupdate data?")
      this.handleTriggerLoading();
      return;
    }

    this.handleSubmitScanQR();
    this.handleTriggerLoading();
  };

  handleSubmitScanQR = () => {
    const {selectedIndex, qrCode} = this.state;
    let data = this.props.data.giftBarcode.map ((item, index) => {
      if (index === selectedIndex) {
        return {
          ...item,
          giftBarcode: qrCode
        }
      }
      return item
    });
    this.props.onChangeValueScanner("giftBarcode", data);
    this.handleShowScanner();
  };

  handleAlertVisibility = (text, type) => {
    this.setState((prevState) => ({
      ...prevState,
      alertVisible: !prevState.alertVisible,
      alertMessage: text,
      alertType: type || null
    }))
  }

  handleFailedQRAlertVisibility = () => {
    this.setState((prevState) => ({
      ...prevState,
      failedQRAlertVisible: !prevState.failedQRAlertVisible,
    }))
  }

  handleTriggerLoading = () => {
    this.setState((prevValue) => ({
      ...prevValue,
      loading: !prevValue.loading,
    }));
  };

  handleChangePage = (tableState) => {
    this.setState((prevValue) => ({
      ...prevValue,
      pagination: {
        ...prevValue.pagination,
        page: tableState.page + 1,
      },
    }));
  };

  handleRowsPerPage = (tableState) => {
    this.setState((prevValue) => ({
      ...prevValue,
      pagination: {
        ...prevValue.pagination,
        page: 1,
        limit: tableState.rowsPerPage,
      },
    }));
  };
  
  handleChangePageQR = (tableState) => {
    this.setState((prevValue) => ({
      ...prevValue,
      paginationQR: {
        ...prevValue.paginationQR,
        page: tableState.page + 1,
      },
    }));
  };

  handleRowsPerPageQR = (tableState) => {
    this.setState((prevValue) => ({
      ...prevValue,
      paginationQR: {
        ...prevValue.paginationQR,
        page: 1,
        limit: tableState.rowsPerPage,
      },
    }));
  };


  render() {
    return (
      <>
        <Tabs>
          <TabList>
            <Tab>Dengan QR</Tab>
          </TabList>
          <TabPanel>
            <SimpleDataTable
              key={`${this.props.data?.giftBarcode?.length}-${this.state.paginationQR.page}`}
              data={this.props.data?.giftBarcode}
              columns={this.denganQRTableColumns}
              toCount={this.props.data?.giftBarcode?.length}
              rowsPerPage={this.state.paginationQR.limit}
              page={this.state.paginationQR.page - 1}
              options={{...defaultTableChange(this.handleChangePageQR, this.handleRowsPerPageQR), serverSide: false}}
            />
          </TabPanel>
        </Tabs>
        <div className="margin-top-15px"></div>
        <Tabs>
          <TabList>
            <Tab>Tanpa QR</Tab>
          </TabList>
          <TabPanel>
            <SimpleDataTable
              key={`${this.props.data?.gift?.length}-${this.state.pagination.page}`}
              data={this.props.data?.gift}
              columns={this.tanpaQRTableColumns}
              toCount={this.props.data?.gift?.length}
              rowsPerPage={this.state.pagination.limit}
              page={this.state.pagination.page - 1}
              options={{...defaultTableChange(this.handleChangePage, this.handleRowsPerPage), serverSide: false}}
            />
          </TabPanel>
        </Tabs>
        {this.state.scannerVisible && (
          <SimpleModal
            title={"Scan QR Here"}
            styles={{ width: "40%" }}
            visible={this.state.scannerVisible}
            onClickClose={this.handleShowScanner}
            content={
              <Scanner
                onScan={this.handleScanQR}
                constraints={{
                  height: { ideal: 720 },
                  video: {
                      facingMode: { exact: "environment" },
                      height: { ideal: 720 }
                  },
                }}
              />
            }
          />
        )}

        {this.state.alertVisible && (
            <SimpleAlert
                visible={this.state.alertVisible}
                title={"Information"}
                onClickClose={this.handleAlertVisibility}
                content={
                  <div>
                    <p>{this.state.alertMessage}</p>
                    {this.state.alertType === "info" ? (
                      <SimpleButton
                        className="margin-top-15px"
                        text="OK"
                        onClick={() => {
                          this.handleAlertVisibility();
                        }}
                      />
                    ) : (
                      <FlexView hAlignContent="center">
                        <SimpleButton
                            className="margin-top-15px"
                            text="Cancel"
                            onClick={() => {
                              this.handleShowScanner();
                              this.handleAlertVisibility();
                            }}
                        />
                        <SimpleButton
                            className="margin-top-15px"
                            text="OK"
                            onClick={() => {
                              this.handleSubmitScanQR();
                              this.handleAlertVisibility();
                            }}
                        />
                      </FlexView>
                    )}
                  </div>
                }
            />
        )}
        {this.state.failedQRAlertVisible && (
            <SimpleAlert
                visible={this.state.failedQRAlertVisible}
                title={"Information"}
                onClickClose={this.handleFailedQRAlertVisibility}
                content={
                  <div>
                    <p>Proses Scan QR Code Gagal. Barang tidak ditemukan.</p>
                    <FlexView hAlignContent="center">
                      <SimpleButton
                          className="margin-top-15px"
                          text="OK"
                          onClick={this.handleFailedQRAlertVisibility}
                      />
                    </FlexView>
                  </div>
                }
            />
        )}

        <SimpleLoadingOverlay active={this.state.loading}/>
      </>
    );
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    setError: (payload) => dispatch(ErrorAction.setError(payload)),
  };
};

export default connect(null, mapDispatchToProps)(HadiahTab);
